export const devBluesnapURL = '/bluesnap/sandpay_bluesnap.js';
export const prodBluesnapURL = '/bluesnap/prod_bluesnap.js';
